import { Tooltip, Typography } from "@material-ui/core";
import React from "react";

const UserEmail = ({ email, addtionalClass }) => {
  return (
    <td className={`truncate-txt ${addtionalClass}`}>
      <Tooltip title={email}>
        <Typography variant="body" color="primary"><a target="_blank" href={`mailto:${email}`}>{email}</a> </Typography>
      </Tooltip>
    </td>
  );
};

export default UserEmail;
